import type { ApiResult } from './types';
import { apiRequest } from './apiClient';
import { prepareProfileImageFile, profileUploadErrorMessage } from '../utils/profileImageUpload';
import { blobFromDmsDownloadResponse, type DmsFileDownloadResponse } from '../utils/dmsFileDownload';

export type UploadToDmsResponse = {
  file_name: string;
  original_file_name: string;
  upload_time: string;
  success: boolean;
};

export async function uploadFileToDmsFolder(file: File): Promise<ApiResult<UploadToDmsResponse>> {
  try {
    const prepared = await prepareProfileImageFile(file);
    const form = new FormData();
    form.append('file', prepared, prepared.name);
    const res = await apiRequest<UploadToDmsResponse>('/v1/file-management/upload', {
      method: 'POST',
      body: form,
    });

    if (!res.ok) return { success: false, message: profileUploadErrorMessage(res.status, res.message) };
    return { success: true, data: res.data };
  } catch {
    return { success: false, message: profileUploadErrorMessage(0) };
  }
}

/** CU-FM-5 / CU-FM-4 — download profile (or temp) folder file as base64 JSON. */
async function downloadFromDmsFolder(folder: 'profile' | 'temp', fileName: string): Promise<ApiResult<Blob>> {
  const key = fileName.trim();
  if (!key) return { success: false, message: 'File name is required.' };

  const res = await apiRequest<DmsFileDownloadResponse>(
    `/v1/file-management/download/${folder}/${encodeURIComponent(key)}`,
  );
  if (!res.ok) return { success: false, message: res.message };

  return blobFromDmsDownloadResponse(res.data);
}

export async function downloadFileFromDms(fileName: string): Promise<ApiResult<Blob>> {
  const profile = await downloadFromDmsFolder('profile', fileName);
  if (profile.success) return profile;
  return downloadFromDmsFolder('temp', fileName);
}
